<script>
import { MARKDOWN_TOOLBAR_ITEMS } from '@modules/global/constants/MarkdownField.js'

export default {
  name: 'MarkdownFieldWidgets',
  inheritAttrs: false,
  props: {
    canEdit: {
      type: Boolean,
      default: false,
    },
    tablePicker: {
      type: Object,
      default: () => ({}),
    },
    tablePickerLabel: {
      type: String,
      default: '',
    },
    menuValue: {
      type: Boolean,
      default: false,
    },
    menuAttach: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      MARKDOWN_TOOLBAR_ITEMS,
    }
  },
}
</script>

<template>
  <div class="aawz-markdown-field__toolbar-tools" v-bind="$attrs">
    <template v-for="(item, index) in MARKDOWN_TOOLBAR_ITEMS">
      <div
        v-if="item.type === 'divider'"
        :key="`divider-${index}`"
        class="aawz-markdown-field__divider"
      >
      </div>
      <v-menu
        v-else-if="item.action === 'createTable'"
        :key="`table-${index}`"
        :value="menuValue"
        :attach="menuAttach"
        offset-y
        :close-on-content-click="false"
        :disabled="!canEdit"
        @input="$emit('table-open', $event)"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="btn-icon-square"
            icon
            x-small
            :disabled="!canEdit"
            :title="item.title"
            v-bind="attrs"
            v-on="on"
            @mousedown.prevent
          >
            <v-icon>{{ item.icon }}</v-icon>
          </v-btn>
        </template>
        <div
          class="aawz-markdown-field__table-picker"
          @mouseleave="$emit('table-clear')"
        >
          <div class="aawz-markdown-field__table-grid">
            <template v-for="row in tablePicker.rows">
              <div
                v-for="col in tablePicker.cols"
                :key="`cell-${row}-${col}`"
                class="aawz-markdown-field__table-cell"
                :class="{
                  'is-selected':
                    row <= tablePicker.hoverRows &&
                    col <= tablePicker.hoverCols,
                }"
                @mouseenter="$emit('table-hover', row, col)"
                @mousedown.prevent="$emit('table-apply', row, col)"
              >
              </div>
            </template>
          </div>
          <div class="aawz-markdown-field__table-label">
            {{ tablePickerLabel }}
          </div>
        </div>
      </v-menu>
      <v-btn
        v-else
        :key="`btn-${index}`"
        icon
        class="btn-icon-square"
        x-small
        :disabled="!canEdit"
        :title="item.title"
        @mousedown.prevent
        @click="$emit('toolbar-action', item)"
      >
        <v-icon>{{ item.icon }}</v-icon>
      </v-btn>
    </template>
  </div>
</template>
